/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Answer_Feedback_Error_Comment_RequiredInputs */

const es_co2_answer_feedback_error_comment_required = /** @type {(inputs: Answer_Feedback_Error_Comment_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe una breve explicación para usar «Otra».`)
};

/**

* @param {Answer_Feedback_Error_Comment_RequiredInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const answer_feedback_error_comment_required = /** @type {((inputs?: Answer_Feedback_Error_Comment_RequiredInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Answer_Feedback_Error_Comment_RequiredInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_answer_feedback_error_comment_required(inputs)
});